export default __webpack_public_path__ + "static/19-2b6483f5393791c51450e08a83ce3129.png";